<div class="login-page">
  <div class="inscription-card">
    <div class="login-logo">
      <img src="/assets/img/seve_tp_logo.png" alt="SEVE-TP" />
    </div>

    <ng-container *ngIf="!existingAccountsPrompt && !existingAccountsSent; else existingAccountsTitle">
      <h1 class="login-title">{{ 'inscription_title' | translate }}</h1>
      <p class="login-subtitle">{{ 'inscription_subtitle' | translate }}</p>
    </ng-container>
    <ng-template #existingAccountsTitle>
      <h1 class="login-title existing-accounts-title">{{ 'inscription_existing_accounts_title' | translate }}</h1>
    </ng-template>

    <div class="existing-accounts" *ngIf="existingAccountsPrompt">
      <div class="existing-accounts-message">
        <mat-icon>warning_amber</mat-icon>
        <p>{{ 'inscription_existing_accounts_prompt' | translate: { email: f.email.value } }}</p>
      </div>
      <div class="email-question-actions">
        <button type="button" class="btn-confirm" [disabled]="sendingExistingAccounts" (click)="closeExistingAccounts()">{{ 'login_btn_submit' | translate }}</button>
        <button type="button" class="btn-outline" [class.spinner]="sendingExistingAccounts" [disabled]="sendingExistingAccounts" (click)="sendExistingAccounts()">
          {{ 'inscription_existing_accounts_send' | translate }}
        </button>
        <button type="button" class="btn-outline" [disabled]="sendingExistingAccounts" (click)="cancelExistingAccounts()">{{ 'common_btn_back' | translate }}</button>
      </div>
    </div>

    <div class="existing-accounts" *ngIf="existingAccountsSent">
      <div class="existing-accounts-message">
        <mat-icon>warning_amber</mat-icon>
        <p>{{ 'inscription_existing_accounts_text' | translate: { email: f.email.value } }}</p>
      </div>
      <button type="button" class="btn-confirm" (click)="closeExistingAccounts()">{{ 'login_btn_submit' | translate }}</button>
    </div>

    <form *ngIf="!existingAccountsPrompt && !existingAccountsSent" [formGroup]="form" [class.show-missing]="showMissingFields" novalidate (ngSubmit)="openConfirm()">
      <div class="block">
        <span class="block-label">{{ 'inscription_profile_type' | translate }}*</span>
        <div class="radio-grid" [class.invalid]="showMissingFields && f.profileType.invalid">
          <button *ngFor="let p of profileTypes" type="button" class="radio-card" [class.selected]="f.profileType.value === p.value" (click)="selectProfile(p.value)">
            <span class="radio-dot"></span>
            <span class="radio-text">{{ p.label | translate }}</span>
          </button>
        </div>
      </div>

      <div class="row-2">
        <div class="field">
          <label>{{ 'inscription_field_lastname' | translate }}*</label>
          <div class="input-wrapper">
            <input type="text" formControlName="nom" />
            <mat-icon class="field-check" *ngIf="showCheck('nom')">check</mat-icon>
          </div>
        </div>
        <div class="field">
          <label>{{ 'inscription_field_firstname' | translate }}*</label>
          <div class="input-wrapper">
            <input type="text" formControlName="prenom" />
            <mat-icon class="field-check" *ngIf="showCheck('prenom')">check</mat-icon>
          </div>
        </div>
      </div>

      <div class="row-2" [class.row-1]="isStudent">
        <div class="field">
          <label>{{ 'inscription_field_email' | translate }}*</label>
          <div class="input-wrapper">
            <input type="email" maxlength="256" formControlName="email" (blur)="onEmailBlur()" [class.invalid]="f.email.hasError('blockedDomain')" />
            <mat-icon class="field-check" *ngIf="showCheck('email')">check</mat-icon>
          </div>
          <span class="field-error" *ngIf="f.email.hasError('blockedDomain')">{{ 'inscription_email_domain_blocked' | translate }}</span>
          <div class="email-question" *ngIf="emailQuestion">
            <p>{{ 'inscription_email_exists_question' | translate }}</p>
            <div class="email-question-actions">
              <button type="button" class="btn-confirm" (click)="keepRegistering()">{{ 'inscription_email_exists_yes' | translate }}</button>
              <button type="button" class="btn-outline" (click)="showExistingAccounts()">{{ 'inscription_email_exists_no' | translate }}</button>
            </div>
          </div>
        </div>
        <div class="field" *ngIf="!isStudent">
          <label>{{ 'inscription_field_function' | translate }}*</label>
          <div class="input-wrapper">
            <input type="text" formControlName="fonction" />
            <mat-icon class="field-check" *ngIf="showCheck('fonction')">check</mat-icon>
          </div>
        </div>
      </div>

      <button *ngIf="!searched" type="button" class="btn-primary btn-find" [class.spinner]="searching" [disabled]="searching || emailQuestion" (click)="onTrouver()">
        <mat-icon>search</mat-icon>
        <span>{{ 'inscription_btn_find' | translate }}</span>
      </button>

      <ng-container *ngIf="searched">
        <div class="org-found-box" *ngIf="orgFound">
          <div class="field">
            <label>{{ 'inscription_org_found' | translate }}*</label>
            <div class="select-wrapper">
              <select formControlName="organisationTrouvee" (change)="onSelectOrganisation($any($event.target).value)">
                <option value="" disabled hidden>{{ 'inscription_org_select_placeholder' | translate }}</option>
                <option *ngFor="let org of foundOrganisations" [value]="org.memberId">{{ org.displayName }}</option>
                <option value="autre">{{ 'inscription_org_other' | translate }}</option>
              </select>
              <mat-icon class="select-chevron">expand_more</mat-icon>
            </div>
          </div>

          <div class="referents-block" *ngIf="f.organisationTrouvee.value && referents.length">
            <span class="referents-title">{{ 'inscription_referents_title' | translate }}</span>
            <p class="referents-text">{{ 'inscription_referents_text' | translate }}</p>
            <input class="referent-field" type="text" *ngFor="let r of referents" [value]="r" readonly />
          </div>
        </div>

        <ng-container *ngIf="orgNotFound">
          <div class="error-box" *ngIf="!orgWasFound && !isOther">
            <mat-icon>error_outline</mat-icon>
            <span>{{ 'inscription_org_not_found' | translate }}</span>
          </div>

          <div class="field" *ngIf="isEntrepriseTp">
            <label>{{ 'inscription_field_country' | translate }}*</label>
            <div class="select-wrapper">
              <select formControlName="pays" (change)="onSelectPays()">
                <optgroup [label]="'inscription_country_featured' | translate">
                  <option *ngFor="let country of featuredCountries" [value]="country.code">{{ country.name }}</option>
                </optgroup>
                <optgroup [label]="'inscription_country_all' | translate">
                  <option *ngFor="let country of countries" [value]="country.code">{{ country.name }}</option>
                </optgroup>
              </select>
              <mat-icon class="select-chevron">expand_more</mat-icon>
            </div>
          </div>

          <div class="field">
            <label>{{ 'inscription_field_organisation' | translate }}*</label>
            <div class="input-wrapper">
              <input type="text" maxlength="30" formControlName="organisation" />
              <mat-icon class="field-check" *ngIf="showCheck('organisation')">check</mat-icon>
            </div>
          </div>

          <ng-container *ngIf="isEntrepriseTp">
            <div class="field" *ngIf="isFrance">
              <label>{{ 'inscription_field_siren' | translate }}*</label>
              <div class="input-wrapper">
                <input type="text" maxlength="9" formControlName="siren" [class.invalid]="f.siren.hasError('sirenKey')" [placeholder]="'inscription_siren_placeholder' | translate" />
                <mat-icon class="field-check" *ngIf="showCheck('siren')">check</mat-icon>
              </div>
              <span class="field-error" *ngIf="f.siren.hasError('sirenKey')">{{ 'inscription_siren_invalid' | translate }}</span>
            </div>

            <div class="block">
              <span class="block-label">{{ 'inscription_fntp_membership' | translate }}*</span>
              <div class="radio-row" [class.invalid]="showMissingFields && f.adhesion.invalid">
                <button *ngFor="let a of adhesions" type="button" class="radio-card" [class.selected]="f.adhesion.value === a.value" (click)="selectAdhesion(a.value)">
                  <span class="radio-dot"></span>
                  <span class="radio-text">{{ a.label | translate }}</span>
                  <mat-icon class="radio-check" *ngIf="f.adhesion.value === a.value">check</mat-icon>
                </button>
              </div>
            </div>

            <div class="field" *ngIf="isAdherente">
              <label class="label-with-help">
                {{ 'inscription_field_tp_number' | translate }}*
                <span class="help-wrap">
                  <mat-icon class="help-icon">help_outline</mat-icon>
                  <span class="help-tooltip">
                    {{ 'inscription_tp_number_tooltip' | translate }}
                    <a class="help-tooltip-link" href="https://www.fntp.fr/annuaire/" target="_blank" rel="noopener noreferrer">{{ 'inscription_tp_number_tooltip_link' | translate }}</a>
                  </span>
                </span>
              </label>
              <div class="input-wrapper">
                <input type="text" maxlength="5" formControlName="numeroTp" />
                <mat-icon class="field-check" *ngIf="showCheck('numeroTp')">check</mat-icon>
              </div>
            </div>

            <ng-container *ngIf="isNonAdherente">
              <div class="field">
                <label>{{ 'inscription_field_company_address' | translate }}*</label>
                <div class="input-wrapper">
                  <input type="text" formControlName="adresse" />
                  <mat-icon class="field-check" *ngIf="showCheck('adresse')">check</mat-icon>
                </div>
              </div>
              <div class="row-cpville">
                <div class="field">
                  <label>{{ 'inscription_field_zipcode' | translate }}{{ isFrance ? '*' : '' }}</label>
                  <div class="input-wrapper">
                    <input type="text" [attr.maxlength]="isFrance ? 5 : 12" formControlName="codePostal" />
                    <mat-icon class="field-check" *ngIf="showCheck('codePostal')">check</mat-icon>
                  </div>
                </div>
                <div class="field">
                  <label>{{ 'inscription_field_city' | translate }}*</label>
                  <div class="input-wrapper">
                    <input type="text" formControlName="ville" />
                    <mat-icon class="field-check" *ngIf="showCheck('ville')">check</mat-icon>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>

        <label class="cgu">
          <input type="checkbox" formControlName="cgu" />
          <span>
            {{ 'inscription_cgu_before' | translate }}
            <a href="https://seve-tp.com/mentionslegales.html#cgu" target="_blank" rel="noopener noreferrer">{{ 'inscription_cgu_link' | translate }}</a>
            {{ 'inscription_cgu_after' | translate }}
          </span>
        </label>

        <button type="submit" class="btn-primary" [disabled]="!f.cgu.value">
          {{ 'inscription_btn_submit' | translate }}
        </button>
      </ng-container>
    </form>
  </div>
</div>

<div class="popin-overlay" *ngIf="showConfirm">
  <div class="popin-card">
    <mat-icon class="popin-close" (click)="closeConfirm()">close</mat-icon>
    <div class="popin-icon"><mat-icon>check_circle</mat-icon></div>
    <h2 class="popin-title">{{ 'inscription_confirm_title' | translate }}</h2>
    <p class="popin-text">{{ 'inscription_confirm_text' | translate }}</p>
    <div class="popin-actions">
      <button type="button" class="btn-outline" (click)="closeConfirm()">{{ 'inscription_confirm_cancel' | translate }}</button>
      <button type="button" class="btn-confirm" [class.spinner]="loading" [disabled]="loading" (click)="confirmCreation()">{{ 'inscription_confirm_ok' | translate }}</button>
    </div>
  </div>
</div>
